const FORMAT = /^\d{5}$/

module.exports = function() {
  return value => {
    if (!value || !FORMAT.test(value)) return false
    return true
  }
}
